import { briefExtrasFormItemsDescription } from '../../constants/briefExtrasFormItemsDescription';

export const getBriefExtrasFormItemsData = () => {
    const formItemsData = [];

    Object.keys(briefExtrasFormItemsDescription).forEach((key) => {
        const formItem = briefExtrasFormItemsDescription[key];

        formItemsData.push({
            name: key,
            ...formItem,
        });
    });

    return formItemsData;
};

export const getAdditionalInfoFieldValidator = () => {
    return {
        validator(_, value) {
            if (!value) {
                return Promise.resolve();
            }

            const maxLength = 6000;

            if (value.length > maxLength) {
                return Promise.reject(
                    `The field value cannot be longer than ${maxLength} characters`
                );
            }

            return Promise.resolve();
        },
    };
};
